import { useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';
import { PaginationAPI } from '@shared';
import { coursesApi } from 'App';

export type CourseUI = {
  uuid: string;
  name: string;
  studentCount: number;
  examCount: number;
};
type CoursesUI = {
  pagination: PaginationAPI;
  courses: CourseUI[];
};

type Args = { partner: string; page: number; limit?: number };

export function useCourses({ partner, page, limit = 10 }: Args): UseQueryResult<CoursesUI> {
  const offset = page - 1;
  const queryClient = useQueryClient();

  return useQuery(
    ['all courses', partner, page, limit],
    () => coursesApi.getPack(partner, offset, limit),
    {
      select: ({ pagination, data }) => ({
        pagination,
        courses: data.map((course) => ({
          uuid: course.course.uuid,
          name: course.course.name,
          studentCount: course.studentCount,
          examCount: course.examCount,
        })),
      }),
      onSuccess: (data) =>
        data.courses.map((course) => queryClient.setQueryData(['course', course.uuid], course)),
      cacheTime: 0,
    }
  );
}
